import http from "./http_common";

class MedicalService {
  queryString(payload) {
    return Object.keys(payload)
      .map((key) => key + "=" + payload[key])
      .join("&");
  }
  loadICDCodesothers(payload) {
    var queryString = Object.keys(payload)
      .map((key) => key + "=" + payload[key])
      .join("&");
    return http.get(`common-icd-codes/list?${queryString}`);
  }
  AddPatientAllery(data) {
    return http.post(`PatientAllergies/save/`, data);
  }
  AddSocialHistory(data) {
    return http.post(`PatientSocialHistory/save/`, data);
  }
  AddPastMedicalHistory(data) {
    return http.post(`PatientPastMedicalHistory/save/`, data);
  }
  AddSurgicalHistory(data) {
    return http.post(`PatientSurgicalHistory/save/`, data);
  }
  AddFamilyHistory(data) {
    return http.post(`PatientFamilyHistory/save/`, data);
  }
  AddMedication(data) {
    return http.post(`PatientMedication/save/`, data);
  }
  AddImmunisationHistory(data) {
    return http.post("/PatientVaccinationHistory/save", data);
  }

  AddPatientReport(data) {
    return http.post(`patientDocument/`, data);
  }

  PatientAllergiesList(payload) {
    var queryString = this.queryString(payload);
    return http.get(`PatientAllergies/list/filter?${queryString}`);
  }

  HSPatientAllergyList(payload) {
    var queryString = this.queryString(payload);
    return http.get(
      `/PatientAllergies/health-summary/allergies?${queryString}`
    );
  }

  PastMedicalHistory(payload) {
    var queryString = this.queryString(payload);
    return http.get(`PatientPastMedicalHistory/list/filter?${queryString}`);
  }

  HSPastMedicalHistory(payload) {
    var queryString = this.queryString(payload);
    return http.get(
      `/PatientPastMedicalHistory/health-summary/pastmedicalhistory?${queryString}`
    );
  }
  PatientSocialHistory(payload) {
    var queryString = this.queryString(payload);
    return http.get(`PatientSocialHistory/list/filter?${queryString}`);
  }

  HSPatientSocialHistory(payload) {
    var queryString = this.queryString(payload);
    return http.get(
      `/PatientSocialHistory/health-summary/social-history?${queryString}`
    );
  }

  PatientSurgicalHistory(payload) {
    var queryString = this.queryString(payload);
    return http.get(`PatientSurgicalHistory/list/filter?${queryString}`);
  }

  HSatientSurgicalHistory(payload) {
    var queryString = this.queryString(payload);
    return http.get(
      `/PatientSurgicalHistory/health-summary/surgical-history?${queryString}`
    );
  }

  PatientFamilyHistory(payload) {
    var queryString = this.queryString(payload);
    return http.get(`PatientFamilyHistory/list/filter?${queryString}`);
  }

  HSPatientFamilyHistory(payload) {
    var queryString = this.queryString(payload);
    return http.get(
      `/PatientFamilyHistory/health-summary/family-history?${queryString}`
    );
  }

  PatientMedication(payload) {
    var queryString = this.queryString(payload);
    return http.get(`PatientMedication/list/filter?${queryString}`);
  }

  HSPatientMedication(payload) {
    var queryString = this.queryString(payload);
    return http.get(
      `/PatientMedication/health-summary/medication?${queryString}`
    );
  }

  PatientImmunisation(payload) {
    var queryString = this.queryString(payload);
    return http.get(`/PatientVaccinationHistory/list/filter?${queryString}`);
  }

  HSPatientImmunisation(payload) {
    var queryString = this.queryString(payload);
    return http.get(
      `/PatientVaccinationHistory/health-summary/vaccination-history?${queryString}`
    );
  }

  DrugList(medicineName) {
    return http.get(
      `/drugInfo/list/filter?medicineName=${medicineName}&pageNo=${1}&pageSize=${20}`
    );
  }
  ShareMedicalrecords(data) {
    return http.post(`patientHistoryAccess/`, data);
  }
  ShareMedicalrecordsFromLink(data) {
    return http.post(`patientHistoryAccess/save-from-invite-link`, data);
  }
  getShareMedicalrecords(payload) {
    var queryString = this.queryString(payload);
    return http.get(`patientHistoryAccess/list/filter?${queryString}`);
  }

  PatientQrList(data) {
    var queryString = this.queryString(data);
    return http.get(`/HealthCardDetails/list/filter?${queryString}`);
  }
  GenerateQr(data) {
    return http.post("/HealthCardDetails/save", data);
  }

  fetchECGgraph(payload) {
    const queryString = this.queryString(payload);
    return http.get(
      `/labTestOrderResult/ecgLatestDoc/list/filter?${queryString}`
    );
  }
}

export default new MedicalService();
